<template>
  <div>
    <object classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=23,0,0,0" :height="height" :width="width">
      <param name="allowFullScreen" value="false"/>
      <param name="menu" value="false"/>
      <param name="quality" value="high"/>
      <param name="scale" value="exactfit"/>
      <param name="movie" :value="url"/>
      <embed allowfullscreen="false" :height="height" menu="false" pluginspage="http://www.macromedia.com/go/getflashplayer" quality="high" scale="exactfit"
             :src="url" type="application/x-shockwave-flash" :width="width"></embed>
    </object>
  </div>
</template>

<script>
  export default {
    name: "swf-player",
    props: ['width', 'height', 'url']
  }
</script>

<style scoped>

</style>
